import React from "react";
import Loader from 'react-loader-spinner'
import HttpService from '../../utils/Http.services';
import { checkTextTranslation, checkTranslation, getObject, groupBy, translate } from "../../utils/useful";
import { getBoundingClientRect } from "../../utils/functions";
import FixedView from "../FixedView";
import { ChromePicker } from "react-color";
import Modal from "../Modal";
import ButtonAnimated from "../buttons/ButtonAnimated";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import TextInput from "./TextInput";
import { customAlphabet } from "nanoid";


import { FormBuilderObjects } from "../../variables/formBuilderData";
import FieldsData from "../FieldsData";
import SidebarView from "../SidebarView";
import { v4 as uuidv4 } from 'uuid';
import FormViewer from "../FormViewer";
import formulaColumnsParser from "../../utils/formulaColumnsParser";


const nanoid = customAlphabet('1234567890abcdefghijklmnopqrstuvwxyz', 10)

class FieldsSelectInput extends React.Component {
    state = {
        options: [],
        isLoading: false,
        tempData: [],
        current: 'color',
        colorInfo: {},
        currentSelect: '',
        cloneOptions: [],
        choosen: [],

        headers: []

    }

    componentDidMount() {
        this.init(true)
        // console.log("componentDidMount")
    }



    componentDidUpdate(prevProps) {

        // console.log(this.props.data)

        // if (prevProps.header.information.items != this.props.header.information.items && this.props.header.information.type === "local") {
        //     // this.setState({ options: this.props.header.information.items })
        //     this.init()
        // }

        // // console.log(this.props.rowData)
        // // console.log(prevProps.rowData)

        // if (JSON.stringify(this.props.rowData) != JSON.stringify(this.state.rowData) && this.props.header.information.rowDependant === true) {
        //     // this.setState({ options: this.props.header.information.items })
        //     this.init()
        // }

        if (JSON.stringify(this.props.data ?? '') != JSON.stringify(prevProps.data ?? '')) {
            this.createParams()
        }
    }


    checkColor = () => {
        let colorInfo = this.state.colorInfo
        if (this.props.header?.information?.color) {
            colorInfo.color = this.props.header.information.color
        }

        if (this.props.header?.information?.background) {
            colorInfo.background = this.props.header.information.background
        }
        this.setState({ colorInfo })
    }




    init() {
        this.fetch()
        // console.log(this.props.data)
        // if (this.props.header.information) {
        //     if (this.props.header.information.type == "local" || !this.props.header.information.type) {

        //         let options = []
        //         let choosen = []

        //         if (this.props.header.information.items && this.props.header.information.items.length > 0) {
        //             options = this.props.header.information.items
        //         }

        //         if (this.props.title && Array.isArray(this.props.title)) {
        //             this.props.title.forEach(element => {
        //                 choosen.push({ title: element, value: element })
        //             });
        //         }
        //         if (this.props.data && Array.isArray(this.props.data)) {
        //             this.props.data.forEach(element => {
        //                 this.props.header.information.items.forEach(item => {
        //                     if (element == item.value) {
        //                         choosen.push({ title: item.title, value: element })
        //                     }
        //                 });
        //             });
        //         }
        //         // console.log(this.props.data, this.props.header.information.items)
        //         this.setState({ options, choosen })
        //     } else if (this.props.header.information.type == "api") {
        //         // console.log(this.props.title)
        //         this.fetch()
        //     }
        // }
    }



    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    toggleOpen = (open) => {
        // console.log("HERE")
        let openState = open != null ? open : !this.state.isOpen

        this.fixedView.showView()

        // if (openState) {
        //     document.addEventListener('mousedown', this.closeBox);
        //     window.addEventListener('scroll', this.getPosition, true);
        //     this.getPosition()

        // } else {
        //     document.removeEventListener('mousedown', this.closeBox);
        //     window.removeEventListener('scroll', this.getPosition);

        // }
        // this.refs.icon.classList.toggle("rotate-180")

        this.setState({ isOpen: openState, data: this.props.data })

    }

    closeBox = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
            this.setState({ isOpen: false, data: this.props.data })
            document.removeEventListener('mousedown', this.closeBox);
            window.removeEventListener('scroll', this.getPosition);

            // this.refs.icon.classList.toggle("rotate-180")

        }
    }


    getPosition = () => {
        // console.log("getPosition")
        let rect = getBoundingClientRect(this.wrapperRef)
        this.setState({ top: rect.top + 35, left: rect.left - 10 })
    }


    changeItem = (prop, selected, dontChangeValue, dontOpen) => {

        var choosen = this.state.choosen
        this.setState({ title: '' }, () => {

        })


        if (selected) {
            for (let i = 0; i < choosen.length; i++) {

                if (choosen[i].value == prop.value) {
                    choosen.splice(i, 1)
                }
            }
        } else {
            choosen.push(prop)
        }

        this.setState({ choosen }, () => {
            if (!dontChangeValue) this.changeValue()
        })

        setTimeout(() => {
            if (!dontOpen) {
                this.toggleOpen(true)
            }
        }, 1);



        if (this.state.tempData.length > 0)
            this.setState({ options: this.state.tempData })

    }



    fetch() {

        // console.log("fetch")
        // console.log(this.props.header.information.filter)
        let body = { ...this.props.header.information.filter }
        if (this.props.header.information.sort) {
            body.sort = this.props.header.information.sort
        }


        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                let baseValue = value.replace(/{/g, '').replace(/}/g, '')

                if (key.startsWith('*row')) {


                } else {

                    let isRequired = false
                    if (baseValue.endsWith('*')) {
                        isRequired = true
                        baseValue = baseValue.slice(0, -1);
                    }

                    if (getObject(this.props.fullData, baseValue)) {
                        // console.log(getObject(this.props.fullData, baseValue))
                        body[key] = getObject(this.props.fullData, baseValue)

                    } else if (this.props.variables && getObject(this.props.variables, baseValue)) {
                        // body[key] = this.props.variables[baseValue]
                        // console.log(baseValue,getObject(this.props.variables, baseValue))

                        body[key] = getObject(this.props.variables, baseValue)

                    } else {


                        if (isRequired) {
                            return
                        }
                        // return
                        // console.log('body', body, key)
                        delete body[key]
                    }
                }
                // console.log("VAR")
            }
        }

        this.setState({ isLoading: true })
        // body = { frames: [body._id] }
        // console.log(body, this.props.header.information.address)

        // return
        HttpService.request(this.props.header.information.address, body, (fetchResult, fetchError) => {
            // console.log('tppppp')
            // console.log(fetchResult, fetchError)
            // return
            if (fetchError) { return }

            // console.log(this.props.data)
            let result = this.props.header.information.fetchKey ? fetchResult.info[this.props.header.information.fetchKey] : fetchResult.info
            let newData = []

            if (Array.isArray(result)) {
                result.forEach(element => {
                    let myData = {}
                    if (this.props.header.information.fields) {
                        Object.entries(this.props.header.information.fields)?.map(([key, value]) => {
                            myData[key] = getObject(element, value)
                        })
                    } else {
                        myData = element
                        element.value = element.key
                    }

                    let alreadyInList = false
                    for (let d = 0; d < newData.length; d++) {
                        let myNewData = newData[d];
                        if (myNewData.value == myData.value) {
                            alreadyInList = true
                            if (checkTranslation(myNewData.information?.label) != checkTranslation(myData.information?.label)) {
                                myNewData.information.label = checkTranslation(myNewData.information?.label) + ' | ' + checkTranslation(myData.information?.label)
                            }
                            break
                        }
                    }

                    if (!alreadyInList) {
                        newData.push(myData)
                    }
                });
            }

            // console.log(newData)
            // let newData = fetchResult.info?.fields

            // for (let i = 0; i < newData.length; i++) {
            //     let element = newData[i];
            //     element.value = element.key
            // }

            let choosen = []

            if (this.props.data) {

                // console.log("HERE1", this.props.data.customFields)

                if (Array.isArray(this.props.data.customFields)) {
                    for (let i = 0; i < this.props.data.customFields.length; i++) {
                        let element = this.props.data.customFields[i];
                        element.value = element.key
                        element.isCustom = true
                        // console.log("HERE")
                        newData.push(element)
                    }
                }


                if (Array.isArray(this.props.data?.choosen)) {
                    this.props.data.choosen.forEach(oneTitle => {
                        // console.log(oneTitle)
                        // let oneTitleId = typeof oneTitle == 'object' ? oneTitle.value : oneTitle
                        newData.forEach(oneNewData => {

                            // console.log(oneNewData.value, oneTitleId)

                            if (oneNewData.value == oneTitle.value) {
                                // console.log("HERE", oneNewData)
                                choosen.push(oneNewData)
                            }
                        });

                    })
                }
                // this.setState({ choosen })

            }
            // console.log("choosen", JSON.stringify(choosen))


            this.setState({
                choosen,
                options: newData,
                isLoading: false
            }, () => {
                this.createParams()
            })
            // }, 1000);


        })

    }


    createParams = () => {

        // console.log('createParams')
        let options = this.state.options
        let params = this.props.params ? JSON.parse(JSON.stringify(this.props.params)) : []
        let fields = []

        for (let i = 0; i < options.length; i++) {
            const option = options[i];
            fields.push(option)
        }


        let param = { label: "{{lang}}Available fields", value: '*record', fields: fields, info: {} }

        let foundId = false

        for (let a = 0; a < param.fields.length; a++) {
            const element = param.fields[a];
            if (element?.key == '_id') {
                foundId = true
            }
        }

        if (!foundId) {
            param.fields.splice(0, 0, { key: '_id', type: 'TextInput', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID' } })
            param.fields.push({ key: 'cDate', type: 'DateInput', information: { label: '{{lang}}Creation date', } })
            param.fields.push({ key: 'uDate', type: 'DateInput', information: { label: '{{lang}}Update date', } })
        }

        params.splice(0, 0, param)

        // console.log("params", params)
        this.setState({ params, showRender: false }, () => {
            setTimeout(() => {
                this.setState({ showRender: true })

            }, 0);
        })
    }


    spliter(source, string) {
        var stringArray = string.split('.')
        var finalString = source
        stringArray.forEach(element => {
            finalString = finalString[element]
        });
        return finalString
    }


    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] === condition) {
                return true
            }
        }
        return false
    }





    // showColor = (prop) => {
    //     let colorInfo = this.state.colorInfo
    //     // if (!colorInfo.color) {
    //     //     colorInfo.color = '#000'
    //     // }
    //     this.props.header?.information?.items?.map((element) => {
    //         if (element.value == prop.value) {
    //             colorInfo.color = element.color
    //             colorInfo.background = element.background
    //         }
    //     })

    //     this.setState({ colorInfo, currentSelect: prop.value }, () => {
    //         this.colorFixedView.showView()
    //     })
    // }
    // handleChange = (e) => {
    //     let color = e.hex
    //     if (color != 'transparent') {
    //         color = color + Math.round(e.rgb.a * 255).toString(16)
    //     }
    //     // console.log('this.props', this.props)
    //     let colorInfo = this.state.colorInfo
    //     colorInfo[this.state.current] = color
    //     let cloneOptions = this.state.cloneOptions
    //     console.log('cloneOptions', cloneOptions)
    //     cloneOptions.map((element) => {
    //         if (element.value == this.state.currentSelect) {
    //             element[this.state.current] = color
    //         }
    //     })
    //     this.setState({ cloneOptions, colorInfo })
    //     // let data = this.props.data ?? {}

    //     // data[this.state.current] = color
    //     // console.log(data)
    //     // // this.setState({ color })
    //     // this.props.changeValue(this.props.header.key, data, this.props.extra,)

    // }

    search = async (value) => {

        // console.log(value)
        this.setState({ title: value })
        if (!this.state.isOpen) {
            this.toggleOpen()
        }

        if (value == "") {
            await this.setState({ options: this.state.tempData })
            await this.setState({ tempData: [] })
        } else {
            if (this.state.tempData.length == 0) {
                await this.setState({ tempData: this.state.options })
            }
            var values = []
            // var values = this.props.data.filter((e) => e.title === value)
            // console.log(this.state.tempData)
            this.state.tempData.forEach(element => {
                if (String(element.title).toLowerCase().includes(String(value).toLowerCase()) || String(element.description).toLowerCase().includes(String(value).toLowerCase())) {
                    values.push(element)
                }
            })
            // console.log(values)

            this.setState({ options: values })

            // }
        }
    }




    renderOption(options, group, level) {

        // console.log(options)
        return (
            <div className="w-100 mt-2 d-flex flex-column text-start">
                {group && (
                    <p className="text-bold font-size-14 mb-1" style={{ paddingLeft: level == null ? 12 : ((level ?? 0) * 10) + 3, paddingRight: level == null ? 12 : ((level ?? 0) * 10) + 10, }}>{checkTranslation(group.label)}</p>
                )}
                {Array.isArray(options) && (
                    options.map((prop, index) => {
                        let selected = false
                        // console.log(this.state.choosen?.value,prop.value)
                        if (this.state.choosen?.value == prop.value) {
                            selected = true
                        }
                        // for (var i = 0; i < this.state.choosen.length; i++) {

                        //     if (prop.value == this.state.choosen[i].value)
                        //         selected = true
                        // }
                        // console.log('optionsoptionsss',prop)
                        return (
                            <div key={index} onClick={() => this.changeItem(prop, selected)} className=" py-2 cursor-pointer select-item-hover flexcb" style={{ paddingLeft: 0, paddingRight: 0, backgroundColor: selected ? '#78b2d030' : null, borderBottom: '1px solid #fff' }}>
                                <div className="px-1 py-1" style={{ color: prop.color, backgroundColor: prop.background, border: prop.background ? '1px solid #eee' : null, minHeight: 26, minWidth: 26, borderRadius: 6 }}>
                                    <p className="main-c2 text-small " style={{}}>{checkTranslation(prop.title)}</p>
                                    {prop.description && (
                                        <p className=" text-smaller mt-1" style={{ color: '#999' }}>{checkTranslation(prop.description)}</p>
                                    )}
                                </div>

                            </div>
                        )
                    })
                )}

                {(!Array.isArray(options) && options != null && typeof options == 'object') && Object.entries(options)?.map(([key, value], index) => {
                    return this.renderOption(options[key]?.children, options[key], (level + 1))
                })}


            </div>
        )
    }
    showConfig = () => {
        let cloneOptions = JSON.parse(JSON.stringify(this.state.options))
        this.setState({ cloneOptions }, () => {
            this.configuration.open()
        })

    }

    // saveConfig = () => {
    //     // console.log('this.props.', this.props.header.information)
    //     // let colorInfo = this.state.colorInfo
    //     let choosen = this.state.choosen
    //     let cloneOptions = JSON.parse(JSON.stringify(this.state.cloneOptions))
    //     let field = {
    //         information: { ...this.props.header.information },
    //         key: this.props.header.key
    //     }
    //     field.information.items = cloneOptions

    //     let body = { _id: this.props.variables.frameId, field }
    //     HttpService.request('updateOneField', body, (fetchResult, fetchError) => {
    //         if (fetchError) {
    //             return
    //         }
    //         if (this.props.functionsHandler && fetchResult.info) {
    //             this.props.functionsHandler(null, 'setFields', fetchResult.info.fields)
    //         }
    //         cloneOptions.map((element) => {
    //             if (element?.value == choosen.value) {
    //                 choosen = element
    //             }
    //         })
    //         this.setState({ options: cloneOptions, choosen }, () => {
    //             this.configuration.close()
    //         })
    //     })
    // }


    onDragEnd = (result) => {
        let items = Array.from(this.state.choosen);
        let [reorderItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderItem);
        // console.log(items)
        this.setState({ choosen: items }, () => {

            let data = this.props.data
            data.choosen = items
            this.props.changeValue(this.props.header.key, data, this.props.extra)
        })
    }

    // changeValueInput = (key, value, extra) => {
    //     // console.log('changeValueInput', key, value)
    //     let cloneOptions = this.state.cloneOptions
    //     cloneOptions.map((element) => {
    //         if (element.value == key) {
    //             element.title = value
    //         }
    //     })
    //     this.setState({ cloneOptions })
    // }

    // addNewRow = () => {
    //     let cloneOptions = this.state.cloneOptions
    //     cloneOptions.push({ title: '', value: nanoid() })
    //     this.setState({ cloneOptions })
    // }
    // removeRow = (key) => {
    //     let cloneOptions = this.state.cloneOptions
    //     let cIndex
    //     let found
    //     cloneOptions.map((element, index) => {
    //         if (element.value == key) {
    //             found = true
    //             cIndex = index
    //         }
    //     })
    //     if (found) {
    //         cloneOptions.splice(cIndex, 1)
    //     }
    //     this.setState({ cloneOptions })
    // }


    openCustomField = (item) => {

        let field = FormBuilderObjects.FormulaInput
        this.setState({ field, currentField: item }, () => {
            this.fieldsDataSidebar.open()
        })
        this.fixedView.hideView()

    }

    addField = () => {

        let customFields = this.props.data?.customFields ?? []
        // console.log("addField")
        let currentField = this.state.currentField ?? {}
        let data = currentField ?? null
        let options = this.state.options

        let isNew = false
        // let form = this.form.getForm()
        if (!currentField?.key) {
            isNew = true
            let id = uuidv4()
            data = {}
            data.id = id
            data.key = 'values.' + id
            data.type = this.state.field?.type
        }
        let information = this.fieldsData.getForm()

        // console.log('informationinformation',information)
        // data.form = this.props.page?._id
        if (information) {
            data.information = information
            if (this.state.type == 'StageInput') {
                data.hideComponent = true
            }

            data.section = 'sec-custom'
            data.isCustom = true
            // data.field.pages = ["information"]

            // this.props.setIsLoadingAddField(true)
            // this.setState({ isLoading: true })
            // this.props.addField(data, () => {
            // this.setState({ isLoading: false })
            // })
            if (isNew) {

                customFields.push(data)
                options.push(data)

            } else {

                for (let i = 0; i < customFields.length; i++) {
                    let customField = customFields[i];
                    if (customField.key == data.key) {
                        customField = data

                        for (let j = 0; j < options.length; j++) {
                            let option = options[j];
                            if (option.value == data.value) {
                                option = data
                            }
                        }
                    }
                }
            }

            this.setState({ options }, () => {

                if (isNew) {
                    this.changeItem(data, false, null, true)
                }
                this.fieldsDataSidebar.close()
                this.fixedView.hideView()

                let final = this.props.data ?? {}
                final.customFields = customFields

                // console.log("final", final)
                this.props.changeValue(this.props.header.key, final, this.props.extra)

            })


        }

    }



    removeCustomField = (item) => {

        this.changeItem(item, true, null, true)

        let customFields = this.props.data?.customFields ?? []
        let options = this.state.options

        for (let i = customFields.length - 1; i >= 0; i--) {
            const customField = customFields[i];
            if (customField.key == item.key) {
                customFields.splice(i, 1)

                for (let j = options.length - 1; j >= 0; j--) {
                    const option = options[j];
                    if (option.value == item.value) {
                        options.splice(j, 1)
                    }
                }
            }
        }


        this.setState({ options }, () => {

            let final = this.props.data ?? {}
            final.customFields = customFields

            this.props.changeValue(this.props.header.key, final, this.props.extra)


        })


    }



    changeValue() {

        let final = this.props.data ?? {}
        let choosen = []

        this.state.choosen.forEach(element => {
            // console.log(element)
            choosen.push({ value: element.value, config: element.config, id: nanoid() })
        })

        // console.log(choosen)
        final.choosen = choosen
        this.props.changeValue(this.props.header.key, final, this.props.extra)
    }


    openConfig = (item) => {

        let headers = [

            { key: 'aggregation', type: 'SelectInput', col: '4', information: { label: '{{lang}}Aggregation type', type: 'local', default: 'sum', items: [{ value: 'sum', title: 'Sum' }, { value: 'avg', title: 'Average' }, { value: 'min', title: 'Minimum' }, { value: 'max', title: 'Maximum' }, { value: 'count', title: 'Count' }], isSearchable: true, placeholder: '{{lang}}Type', required: true } },
            { key: 'name', type: 'TextInput', col: '4', information: { label: '{{lang}}Custom name', placeholder: '{{lang}}Optional custom name', required: false } },

        ]

        let separateColumnsHeader = { key: 'separateColumns', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Separate as multiple columns', default: false, required: false }, }

        let items = []
        if (Array.isArray(this.state.options)) {
            for (let i = 0; i < this.state.options.length; i++) {
                const option = this.state.options[i];
                if (item.value != option.value) {
                    items.push({ value: option.value, title: option.information?.label, image: FormBuilderObjects[item.type]?.icon })
                }
            }
        }


        let valueHeader = {
            key: 'value', type: 'SelectInput', information: { label: '{{lang}}Value field', type: 'local', items, required: true },
            dependencies: [{
                refKey: ['aggregation', 'separateColumns'], targetKey: 'value',
                conditions: [{
                    root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.aggregation' }, operator: { value: '!=' }, target: { value: "count" } }, 2: { id: 2, source: { value: '@data.separateColumns' }, operator: { value: '==' }, target: { value: true } } }, },
                    effect: { show: true, }
                }],
                else: { show: false },
                init: true,

            }],
            showMain: false
        }

        // console.log(item)

        if (item.type == 'FormulaInput') {

            let columns = formulaColumnsParser.extractOutputLiteralsFromFormula(item.information?.formula)
            // console.log(columns)
            if (columns.length > 0) {
                headers.splice(0, 0, separateColumnsHeader)

                headers.splice(2, 0, valueHeader)

            }

        }

        // console.log(headers)


        this.setState({ currentConfigItem: null, headers }, () => {
            this.setState({ currentConfigItem: item }, () => {

                this.configSidebar.open()

            })
        })

    }


    applyConfig = () => {

        let currentConfigItem = this.state.currentConfigItem
        let choosen = this.state.choosen ?? []
        let final = this.props.data ?? {}
        let form = this.configForm.getForm()

        if (form) {
            // console.log(choosen, final, currentConfigItem)
            if (Array.isArray(final.choosen)) {

                for (let i = 0; i < final.choosen.length; i++) {
                    let element = final.choosen[i];
                    if (element.value == currentConfigItem.value) {
                        element.config = form

                        // console.log(element)
                        for (let j = 0; j < choosen.length; j++) {
                            let myChoosen = choosen[j];
                            if (myChoosen.value == currentConfigItem.value) {
                                myChoosen.config = form

                            }
                        }
                    }

                }

            }

            this.setState({ choosen }, () => {
                this.props.changeValue(this.props.header.key, final, this.props.extra)
            })

            this.configSidebar.close()
        }

    }



    render() {
        let dataValue = ''
        if (this.props.data != null) {
            dataValue = typeof this.props.data == "object" ? (this.props.data._id ?? this.props.data.id) : this.props.data
        }
        let info = this.props.header?.information


        return (

            <>
                <div className='w-100' style={{ position: 'relative', }} ref={el => this.currentNode = el}>
                    <div className="w-100 h-100 cusrsor-pointer" style={{ position: 'relative' }}  >


                        {/* {this.props.header.information.placeholder && !this.state.choosen?.length && (
                        <div className="h-100 flexc w-100 cursor-pointer" style={{ top: 0, padding: '4px 0px 3px 0px' }}>
                            <p className={' mrd-1 mld-1 placeholder w-100 '}>{checkTextTranslation(this.props.header.information.placeholder)}</p>
                        </div>
                    )} */}

                        <div style={{ position: "fixed", top: "0", left: "0" }} ref={(el) => (this.setPositionDiv = el)}></div>


                        <DragDropContext onDragEnd={(result) => this.onDragEnd(result)}>
                            <Droppable droppableId="droppable">
                                {(provided) => (
                                    <div className="w-100" style={{ transform: "none" }} {...provided.droppableProps} ref={provided.innerRef}>
                                        {Array.isArray(this.state.choosen) && this.state.choosen.map((item, index) => {

                                            if (item && item.type != "StaticText") {
                                                return (
                                                    <Draggable key={item.key} draggableId={item.key} index={index}>
                                                        {(provided, snapshot) => {
                                                            if (snapshot.isDragging) {
                                                                if (!provided.draggableProps) {
                                                                    provided.draggableProps = { style: { boxShadow: "0px 0px 30px #10101090", zIndex: "10" } };
                                                                }
                                                                let bound = getBoundingClientRect(this.setPositionDiv);
                                                                // let scrollTop = this.scrollContainer.scrollTop
                                                                const offset = { x: bound.left, y: bound.top };
                                                                let x = (provided.draggableProps?.style?.left ?? 0) - offset.x;
                                                                let y = (provided.draggableProps?.style?.top ?? 0) - offset.y;
                                                                // y = y - scrollTop
                                                                provided.draggableProps.style.left = x + 'px';
                                                                provided.draggableProps.style.top = y + 'px';
                                                                provided.draggableProps.style.boxShadow = "0px 0px 10px #10101020";
                                                                provided.draggableProps.style.zIndex = "10";
                                                            }
                                                            return (
                                                                <div className="fields-box w-100">
                                                                    <div className="fields flexcb br-6 py-2 px-1" style={{ transform: "none" }} ref={provided.innerRef} {...provided.draggableProps}>
                                                                        <div className="flexc">
                                                                            <div style={{ width: "15px" }} {...provided.dragHandleProps}>
                                                                                <img className="" style={{ opacity: 0.8 }} src="/assets/icons/drag-and-drop.svg" width="13px" alt="" />
                                                                            </div>

                                                                            <div className="br-4 flexcc" style={{ background: '#f6f6f6', width: 22, height: 22 }}>
                                                                                <img className="" src={FormBuilderObjects[item.type]?.icon} height="17px" alt="" />
                                                                            </div>
                                                                            {/* <Switch onChange={this.handleChange} checked={this.state.checked} /> */}
                                                                            {/* <img src={item.src} className="mx-1" style={{ width: "10px" }} /> */}
                                                                            {item.config?.name ? (
                                                                                <div>
                                                                                    <p className="text-smaller mx-2">{checkTranslation(item.config?.name)}</p>
                                                                                    <p className="text-smallest mx-2" style={{ textDecoration: 'line-through' }}>{checkTranslation(item?.information?.label)}</p>
                                                                                </div>
                                                                            ) : (
                                                                                <p className="text-smaller mx-2">{checkTranslation(item?.information?.label)}</p>

                                                                            )}
                                                                        </div>
                                                                        <div className="flexc">

                                                                            <div className="font-size-10 br-4 px-2 py-1" style={{ background: '#eee', color: '#777' }}>
                                                                                {translate(item.config?.aggregation ?? 'Sum')}
                                                                            </div>

                                                                            <button onClick={(e) => { e.stopPropagation(); this.changeItem(item, true, null, true) }} style={{ width: "15px" }} className="mx-1 cursor-poiner flexcc">
                                                                                <img className="" style={{}} src="/assets/icons/useful/x-mark.png" width="13px" alt="" />
                                                                            </button>

                                                                            <button style={{ width: "15px" }} className="mx-1 cursor-poiner flexcc" onClick={() => this.openConfig(item)}>
                                                                                <img className="" style={{}} src="/assets/icons/useful/settings.png" width="13px" alt="" />
                                                                            </button>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }}
                                                    </Draggable>
                                                );
                                            }
                                        })}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>

                        <button className="text-link px-1 py-1" onClick={() => !this.props.header.information?.disabled ? this.toggleOpen(true) : ''}>
                            <p className="font-size-13">+{translate("Add field")}</p>
                        </button>

                        {/* {this.state.choosen.map((prop, index) => {
                        return (
                            <div key={index} className="" style={{ display: 'inline-flex', alignItems: 'center', paddingTop: 2, paddingBottom: 2 }}>
                                <div className="flexcc" key={index} style={{ padding: 5, backgroundColor: '#eee', borderRadius: 20, marginRight: 2, marginLeft: 2, flexWrap: 'nowrap', paddingLeft: 7, paddingRight: 7 }}>

                                    <button onClick={(e) => { e.stopPropagation(); this.changeItem(prop, true, null, true) }} className="br-20 p-1 flexcc mrd-1" style={{ backgroundColor: '#ffffffcc', width: 16, height: 16 }}>
                                        <img className="opacity-5" src="/assets/icons/close.svg" style={{ paddingLeft: 0, color: '#78b2d0', width: 12, height: 12, }} alt="" />
                                    </button>

                                    <p style={{ whiteSpace: 'nowrap', marginBottom: 0, marginRight: 2, marginLeft: 2, fontSize: 12, marginTop: 0, color: '#202020' }}>{checkTranslation(prop.title)}</p>

                                </div>

                            </div>
                        )
                    })} */}



                        {this.state.isLoading && (
                            <div style={{ position: 'absolute', top: 0, right: 10 }}>
                                <Loader
                                    type="Oval"
                                    color="rgba(0,122,255,1)"
                                    height="25"
                                    width="25"
                                />
                            </div>
                        )}

                    </div>




                    <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={this.onHide} topOffset={10} bottomOffset={30} zIndex={15} xOffset={-5} minWidth={160} maxWidth={300} rightAlign={false}>

                        <div style={{ display: 'flex', width: '100%', maxWidth: 300, zIndex: 40 }}>

                            <div className={'search-drop-down   py-1 pb-2'} style={{ display: 'flex', flexDirection: 'column', width: '100%', backgroundColor: '#ffffff', borderColor: '#eee', borderRadius: 6, maxHeight: 250, overflow: 'auto', boxShadow: '0px 0px 30px rgba(0,0,0,0.2)' }}>

                                <div className="py-2 px-2" style={{ borderBottom: '1px solid #eee' }}>
                                    <p className="text-small text-bold px-1">{translate("Select fields ")}</p>
                                </div>
                                {/* <p className="text-smaller color-gray-2">{translate("Fields can be customized. Custom formula fields can also be used.")}</p> */}

                                <div className="w-100 mt-2 px-2 mb-1">

                                    <button className="text-link  px-1" onClick={() => this.openCustomField()}>
                                        <p>+{translate("Add formula field")}</p>
                                    </button>
                                </div>

                                {Array.isArray(this.state.options) && this.state.options.map((item, index) => {

                                    if (item.type != "StaticText") {

                                        let selected = false
                                        for (var i = 0; i < this.state.choosen.length; i++) {

                                            if (item?.value == this.state.choosen[i]?.value)
                                                selected = true
                                        }
                                        // console.log(item)
                                        return (
                                            <div className=" w-100 cursor-pointer  px-1 flexcb" style={{}}>
                                                <div className="fields w-100 flexcb br-6 p-2 px-2 select-item-hover" style={{ transform: "none", backgroundColor: selected ? '#78b2d030' : null, }} onClick={() => this.changeItem(item, selected)} >
                                                    <div className="flexc">
                                                        <div className="br-4 flexcc" style={{ background: '#f6f6f6', width: 22, height: 22 }}>
                                                            <img className="" src={FormBuilderObjects[item.type]?.icon} height="17px" alt="" />
                                                        </div>
                                                        <p className="text-smaller mx-2">{checkTranslation(item?.information?.label)}</p>
                                                    </div>


                                                </div>

                                                {item.isCustom && (
                                                    <div className="flexc">

                                                        <button onClick={(e) => { e.stopPropagation(); this.removeCustomField(item) }} style={{ width: "15px" }} className="mx-1 cursor-poiner">
                                                            <img className="" style={{}} src="/assets/icons/useful/trash-o.svg" width="13px" alt="" />
                                                        </button>


                                                        <button style={{ width: "15px" }} className=" cursor-poiner" onClick={() => this.openCustomField(item)}>
                                                            <img className="" style={{}} src="/assets/icons/useful/settings.png" width="13px" alt="" />
                                                        </button>
                                                        {/* <div className="mx-1 cursor-poiner">
                                                            <p className="text-smaller text-link">{translate("Add")}</p>
                                                        </div> */}

                                                    </div>
                                                )}
                                            </div>
                                        )
                                    }
                                })}

                            </div>


                        </div>
                    </FixedView>




                </div>


                <SidebarView width={this.props.width} zIndex={40} ref={el => this.fieldsDataSidebar = el} widthCondition={{ xs: "80%", sm: "50%", md: '50%', lg: "35%", xl: "25%" }} >

                    <div className='  h-100 white-bg'>
                        <div className='flexcb  position-sticky top-0 w-100' style={{ padding: '6px 14px', background: '#fff', zIndex: 2, borderBottom: '1px solid #eee', }}>
                            <div className='flexc' style={{}}>
                                <button onClick={() => this.fieldsDataSidebar.close()}>
                                    <img width={18} className='mrd-2 flexcc invert' src='/assets/icons/arrow-left-white.svg' alt="" />
                                </button>

                                <p className=' font-size-14 text-semibold' style={{ color: '#000' }}>{this.state.currentField ? translate('Edit Custom Field') : translate('Add Custom Field')}</p>

                            </div>


                            <ButtonAnimated
                                iconwidth='24px'
                                onClick={() => { !this.state.isLoading && this.addField() }}
                                title={translate('Submit')}
                                icon='/assets/icons/plus-white.svg'
                                textColor={this.props.colors?.textColor ?? '#000'}
                                invert={!this.props.colors?.iconInvert}
                                bg={this.props.colors?.background ?? '#eee'}
                                isLoading={this.state.isLoading}
                            />

                        </div>

                        <div className='scroll-no-scrollbar pt-2' style={{ height: 'calc(100% - 60px)' }}>
                            <FieldsData ref={el => this.fieldsData = el} initData={this.state.currentField?.information} colors={this.props.colors} addField={this.props.addField} currentFrame={this.props.currentFrame} width={this.props.width} changeStage={this.changePage} stage={1} stageName={'form'} field={this.state.field} params={this.state.params} variables={this.props.variables} />
                        </div>

                    </div>


                </SidebarView>





                <SidebarView width={this.props.width} zIndex={40} ref={el => this.configSidebar = el} widthCondition={{ xs: "80%", sm: "50%", md: '50%', lg: "35%", xl: "25%" }} left={50}>

                    <div className='  h-100 white-bg d-flex flex-column'>
                        <div className='flexcb  position-sticky top-0 w-100' style={{ padding: '6px 14px', background: '#fff', zIndex: 2, borderBottom: '1px solid #eee', }}>
                            <div className='flexc' style={{}}>
                                <button onClick={() => this.configSidebar.close()}>
                                    <img width={18} className='mrd-2 flexcc invert' src='/assets/icons/arrow-left-white.svg' alt="" />
                                </button>

                                <p className=' font-size-14 text-semibold' style={{ color: '#000' }}>{translate('Field config')}</p>

                            </div>


                            <ButtonAnimated
                                iconwidth='24px'
                                onClick={() => { !this.state.isLoading && this.applyConfig() }}
                                title={translate('Apply')}
                                icon='/assets/icons/plus-white.svg'
                                textColor={this.props.colors?.textColor ?? '#000'}
                                invert={!this.props.colors?.iconInvert}
                                bg={this.props.colors?.background ?? '#eee'}
                                isLoading={this.state.isLoading}
                            />

                        </div>


                        <div className='scroll-no-scrollbar pt-2 flex-1' >

                            <FormViewer ref={el => this.configForm = el} initData={this.state.currentConfigItem?.config} headers={this.state?.headers} formClass="bordered-form" inputClass={'bordered-input'} params={this.state.params} />

                        </div>

                    </div>


                </SidebarView>



            </>

        );
    }
}

export default FieldsSelectInput;
